<template>
	<div>
		<!-- PLAY RECORDED AUDIO BUTTON -->
		<v-btn
			v-if="(debugStore.altKeyHeld || debugStore.debugMode) && message.audioId"
			size="x-small"
			:style="{
				position: 'absolute',
				top: '5px',
				right: isMe ? 'auto' : '5px',
				left: isMe ? '5px' : 'auto',
				'z-index': 10000,
			}"
			:disabled="audioPlayerStore.playing && !playing"
			:icon="playerError ? 'mdi-exclamation' : playing ? 'mdi-stop' : 'mdi-play'"
			:color="playerError ? 'red' : playing ? 'white' : 'black'"
			@click="() => toggleAudio(message.audioId ?? '')"
		/>
		<!-- ADD TO HALLUCINATION FILTER BUTTON -->
		<!-- <v-btn
			v-if="(showFilterButton || debugStore.debugMode) && message.translation"
			size="x-small"
			:style="{
				position: 'absolute',
				top: '5px',
				right: isMe ? 'auto' : '40px',
				left: isMe ? '40px' : 'auto',
				'z-index': 10000,
			}"
			icon="mdi-filter-plus"
			@click="() => addFilter(message.messageId)"
		/> -->
	</div>
</template>

<script setup lang="ts">
import type { Session, Message } from "@lr-notitia/notitia-alternis/schemas";
import { ref, computed } from "vue";
// import { apiConfig } from "@lr-notitia/notitia-alternis/client";
import { useDomainStore } from "../../../../store/domain";
// import { useSessionStore } from "../../../../store/alternis/session";
import { useDebugStore } from "../../../../store/debug";
import { useAudioPlayerStore } from "../../../../store/alternis/audioPlayer";

const domainStore = useDomainStore();
// const sessionStore = useSessionStore();
const audioPlayerStore = useAudioPlayerStore();
const debugStore = useDebugStore();

const props = defineProps<{ message: Message }>();

const playing = ref(false);
const playerError = ref(false);
// const session = computed<Session>(() => sessionStore.session || { sessionId: "", users: [], messages: [], bots: [] });
const isMe = computed(() => props.message.userId === domainStore.account.id);

function toggleAudio(audioId: string) {
	if (playing.value) {
		audioPlayerStore.stop(audioId);
	} else {
		audioPlayerStore
			.play(audioId, 1, () => {
				playing.value = false;
			})
			.then(() => {
				playing.value = true;
			})
			.catch(() => {
				playing.value = false;
				playerError.value = true;
			});
	}
	playing.value = !playing.value;
}

// function addFilter(messageId: string) {
// 	const message = session.value.messages.find((m) => m.messageId === messageId);
// 	if (!message) return;
// 	const lang = message.lang;
// 	const text = message.words.map((s) => s.value.replaceAll(" ", "")).join(" ");
// 	if (!text) return;
// 	fetch(`${apiConfig.host}${apiConfig.basePath}/filter`, {
// 		method: "POST",
// 		headers: {
// 			Authorization: `Bearer ${apiConfig.authToken}`,
// 			"Content-Type": "application/json",
// 		},
// 		body: JSON.stringify({ lang, text }),
// 	}).catch(() => {});
// }
</script>
